import { fetchFromOldApi } from '~/services/Http';

export type yearlyVacType = {
  fHolidayYear?: number;
  fHolidayCode?: string;
  fHolidayBalance?: number;
};

export type vacBalDeduction = {
  fDeductionStartDate: string;
  fDeductionEndDate: string;
  fDeductionDays: string;
  fDeductionReason: string;
  fDeductionInfo: string;
};

export type vacationDaysHistoryData = {
  fVacationBalanceEmpId: number;
  fVacationBalance: number;

  fVacationBalanceExtra?: number;
  fVacationBalanceSuppl1?: number;
  fVacationBalanceSuppl2?: number;
  fVacationBalanceSuppl1Spent?: number;
  fVacationBalanceSuppl2Spent?: number;

  fVacationBalanceBank1?: number;
  fVacationBalanceBank2?: number;
  fVacationBalanceBank3?: number;

  fVacationBalanceDeduction?: vacBalDeduction;

  fYearlyVacationBalances: yearlyVacType[];

  fVacationBalanceUpdatedTime: string;
  fVacationBalanceUpdatedUserId: number;
  fVacationBalanceUpdatedName?: string;
};

export const getVacHistoryTableData = (iEmpId: string) =>
  fetchFromOldApi(
    `/json/employee/${iEmpId}/absenceshort/balance?period=all`,
  ).then((r) => r.json());

export type IFormInput = {
  fVacationBalance: number;
  fVacationBalanceBank1?: number;
  fVacationBalanceBank2?: number;
  fVacationBalanceBank3?: number;
  fVacationBalanceEmpId: number;
  fVacationBalanceExtra?: number;
  fVacationBalanceSuppl1?: number;
  fVacationBalanceSuppl1Spent?: number;
  fVacationBalanceSuppl2?: number;
  fVacationBalanceSuppl2Spent?: number;
};

export const putEmpVacBalanceData = async (
  json: IFormInput,
  iEmpId: number,
) => {
  return await fetchFromOldApi(
    '/json/employee/' + iEmpId + '/absenceshort/balance',
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(json),
    },
  ).then((r) => r.json());
};
